import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { ApplicationControllerService } from '../cc-api/services';
import { actionDisabled } from '../utils/action-disabled-utils';

@Injectable({
  providedIn: 'root',
})
export class UserAuthoritiesService {
  private authoritiesList: string[] = [];
  private clusterRoleBinding = {};
  buttonDisabledTooltip = 'Access is forbidden';

  constructor(
    private applicationControllerService: ApplicationControllerService,
  ) {}

  initAuthorities(userData) {
    this.authoritiesList = [];
    this.clusterRoleBinding = userData?.clusterRoleBinding;
    userData?.authorities?.forEach((ele) => {
      this.authoritiesList.push(ele.authority);
    });
  }

  //call me API and get the authorities
  // private getAuthorities() {
  //   this.applicationControllerService.meUsingGET().subscribe(
  //     (data) => {
  //       data.authorities.forEach((ele) => {
  //         this.authoritiesList.push(ele.authority);
  //         console.log('authority is set');
  //       });
  //     },
  //     (error) => {
  //       console.log(error);
  //     },
  //   );
  // }

  isActionDisabled(action?: string, clusterId?: string, actionsList?: []) {
    return actionDisabled(
      this.clusterRoleBinding,
      this.authoritiesList,
      action,
      clusterId,
      actionsList,
    );
  }
  resetData() {
    this.authoritiesList = [];
    this.clusterRoleBinding = {};
  }

  hasSomePermission(requiredPermissions) {
    const hasPermission =
      requiredPermissions?.length === 0 ||
      requiredPermissions?.some((permission) =>
        this.authoritiesList?.includes(permission),
      );
    return hasPermission;
  }

  getAuthoritiesList() {
    return this.authoritiesList;
  }
}
